/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} My_Integrations_Disconnect_AriaInputs */



/**
* | output |
* | --- |
* | "Disconnect {name}" |
*
* @param {My_Integrations_Disconnect_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_disconnect_aria = /** @type {((inputs: My_Integrations_Disconnect_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Disconnect_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} trennen`)
	return /** @type {LocalizedString} */ (`Disconnect ${i?.name}`)
});